import { combineReducers } from 'redux-immutable'

import { reducer as homeReducer } from '../pages/home/store'
import { reducer as loginReducer } from '../pages/login/store'
import { reducer as collectReducer } from '../pages/collect/store'
import { reducer as adminReducer } from '../pages/admin/store'
import { reducer as imageSearchReducer } from '../pages/imageSearch/store'
import { reducer as detailReducer } from '../pages/detail/store'

const reducer = combineReducers({
    home: homeReducer,
    login: loginReducer,
    collect: collectReducer,
    admin: adminReducer,
    image: imageSearchReducer,
    detail: detailReducer,
})

export default reducer